import styled from 'styled-components';

export const PinCodeSizeSelectWrapper = styled.div`
  select {
    width: 55px;
  }

  div {
    padding: 0;
  }
`;
